import axios from 'axios'
import dayjs from 'dayjs'
import context from './context'

export const loggedIn = () =>{ 
    return window.localStorage.getItem('token') ? true : false
}

export const commaFormat = value => {

    if(!value) return

    var nStr = value + ''
    nStr = nStr.replace( /\,/g, "")
    var x = nStr.split( '.' )
    var x1 = x[0]
    var x2 = x.length > 1 ? '.' + x[1] : ''
    var rgx = /(\d+)(\d{3})/

    while ( rgx.test(x1) ) {
        x1 = x1.replace( rgx, '$1' + ',' + '$2' )
    }

    return (x1 + x2).toLocaleString("fa")

}

const checkExpirationAndRefreshToken = async() => {
    const expiration = context.getTokenExpiration()
    const diff = dayjs(expiration).diff(dayjs(), 'hour')


    if( !expiration || diff < 1 ){
        await context.refreshToken()
    }

    return

}

export const ajax = async ({ method, url, data, hasToken, token, snackbar, headers = {}, errmessage="خطا در دریافت اطلاعات"}) => {
    let headersObject = { ...headers}
    if(hasToken) {
        await checkExpirationAndRefreshToken()
        headers.Authorization = `Bearer ${window.localStorage.getItem('token')}`
    }
    if(token) headers.Authorization = `Bearer ${token}`

    const axiosObject = {
        url,
        method: method ? method : 'GET',
        headers
    }

    if (data) axiosObject.data = data

    const res = await axios(axiosObject, headersObject)
        .catch(e => {
            console.log(e)
            console.log(e.message)
            const message = e.response && e.response.data && e.response.message || errmessage
            snackbar(message, {variant: 'error'})
        })

    if(!res) return
    return res
}
